import { FileQuestion, Lock, TriangleAlert } from 'lucide-react'
import { isRouteErrorResponse, Link, useRouteError } from 'react-router'
import { ApiError } from '../lib/api'
import { Page } from './AppShell'
import { Button, ButtonLink, EmptyState } from './ui'

/** Error boundary for routes: not found, no access, or an unexpected failure (with a retry). */
export function RouteError({ fullPage = false }: { fullPage?: boolean }) {
  const error = useRouteError()
  const status = error instanceof ApiError ? error.status : isRouteErrorResponse(error) ? error.status : 500

  let content
  if (status === 404) {
    content = (
      <EmptyState icon={<FileQuestion className="size-5" />} title="Not found" action={<ButtonLink to="/">Go to Home</ButtonLink>}>
        {error instanceof ApiError ? error.message : 'This page does not exist or was removed.'}
      </EmptyState>
    )
  } else if (status === 403) {
    content = (
      <>
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-navy-500">Restricted</p>
        <h1 className="mt-3 flex items-center gap-3 text-4xl font-bold tracking-tight"><Lock className="size-7" /> Access not available</h1>
        <p className="mt-3 max-w-xl text-lg text-navy-500">{error instanceof ApiError ? error.message : 'You do not have access to this page.'}</p>
        <Link to="/" className="mt-6 inline-flex text-sm font-medium text-brand-600 hover:underline">Back to Home →</Link>
      </>
    )
  } else {
    content = (
      <EmptyState icon={<TriangleAlert className="size-5" />} title="Something went wrong" action={<Button onClick={() => window.location.reload()}>Try again</Button>}>
        {error instanceof ApiError ? error.message : 'The page could not be loaded.'}
      </EmptyState>
    )
  }
  return fullPage ? <main className="min-h-screen"><Page className="py-20">{content}</Page></main> : <Page className="py-20">{content}</Page>
}
